import React, { useCallback, useState } from "react";
import clsx from "clsx";
import { useTranslation, Trans } from 'react-i18next';

function StageDownTooltip({ count }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [open]);
  return (
    <div className="lr-mySB-item item-stage">
      <div className="lr-mySB-tit">
        <p>{t("LC_05_07_01.msg012")}</p>
        <div className="lr-mySB-tit-tooltip">
          <button className="btn-help btn-tooltip" onClick={handleClick}></button>
          <div
            className={clsx({
              "tooltipBox topCenter": true,
              active: open,
            })}
          >
            <div className="tooltip-def">
              {/* <Trans t={t} count={count}>
                LC_05_07_01.msg013
              </Trans> */}
                <p>
                  {/* {t("LC_05_07_01.msg013")} */}
                  <Trans t={t} count={count}>
                    LC_05_07_01.msg013
                  </Trans>
                  {/* 예전 스테이지에서 풀어봤던<br></br>
                  <span className="t-underline">문제 {{count}}개</span> 잘 알고 있는지
                  <br></br>
                  확인해 봤어. */}
                  <button
                    onClick={handleClick}
                    className="btn-closeTooltip btn-close-tooltip"
                  ></button>
                </p>
            </div>
          </div>
        </div>
      </div>
      <button className="lr-mySB-txt" onClick={handleClick}>{count}개</button>
    </div>
  );
}

export default StageDownTooltip;
